module.exports = __webpack_public_path__ + "static/media/Banner-halo-mobile.50aeb562.png";